import * as React from "react";

// NOTE: This hook was extracted because document title setting is used in multiple
// places (EditorApp, AuthenticatedUserRequiredRoute, SharePageTemplateLayout) and
// each needs the same dev mode suffix logic. Centralizing here avoids duplication.
export function useDocumentTitle(title: string | null | undefined) {
  // eslint-disable-next-line replo/no-use-effect -- Legacy effect - may or may not be necessary
  React.useEffect(() => {
    if (title) {
      const isDev = window.__BUILD_MODE__ === "development";
      const branchName = window.__DEV_BRANCH_NAME__;
      // NOTE (Noah, 2026-05-06, REPL-26878): In dev mode, prepend the git branch
      // name so developers can identify which worktree/branch a tab belongs to.
      // e.g. "noah/my-branch - Dashboard - Replo Dev Mode"
      const branchPrefix = isDev && branchName ? `${branchName} - ` : "";
      const modeSuffix = isDev ? " - Replo Dev Mode" : " - Replo";
      document.title = `${branchPrefix}${title}${modeSuffix}`;
    }
  }, [title]);
}
